import media from '../media/media.js';

const mediaListTemplate = require('./media-list.ejs');
const mediaListContainer = document.querySelector('.media-list'),
    exists = typeof(mediaListContainer) != 'undefined' && mediaListContainer != null;

document.addEventListener('DOMContentLoaded', () => {
    if (exists) {
        let mediaLists = new mediaList(mediaListContainer, mediaListTemplate).init();
    };
});

class mediaList extends media {

    constructor(container, template) {
        super(container, template);
    }

    init() {
        super.getData(true);
    }
}


// WEBPACK FOOTER //
// ./frontend/components/media-list/media-list.js